export default "__VITE_ASSET__CofP7Yxb__"